import { prefixObjectValues } from '../../utils';
const form = {
  compType: 'comp-type',
  pricePerHour: 'price-per-hour',
  pricePerShift: 'price-per-shift',
  pricePerRvu: 'price-per-rvu',
  rvusPerPeriod: 'rvus-per-period',
  rvuPeriod: 'rvu-period',
};
export default prefixObjectValues(form, 'compensation-form');
